export default __webpack_public_path__ + "static/B0162-3eee071ab9ec1a94386ccc2b0c3e72ee.png";